import React from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import "./CustomDatetime.css"; // import CSS overrides

const CustomDatetime = ({value, onChange, dateFormat = "YYYY-MM-DD", timeFormat = "hh:mm:ss A", ...props}) => {
	return (
		<div className="custom-datetime-wrapper">
			<Datetime
				value={value}
				onChange={onChange}
				dateFormat={dateFormat}
				timeFormat={timeFormat}
				pla
				{...props}
			/>
		</div>
	);
};

export default CustomDatetime;
